import { ScriptDispatcher } from "../../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/common/scriptDispatcher";
import { notNull } from "../../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/common/assert";
import { TriggerReloadEvent } from "../base/triggerReloadEvent";

export class ReloadManager {
    public cmsReloadModule(event: Event): Promise<HTMLElement> | null {
        event.preventDefault();
        event.stopImmediatePropagation();

        const target = event.target as HTMLInputElement;
        if (!target) {
            return null;
        }
        const form = target.closest("form") as HTMLFormElement;
        if (!form) {
            return null;
        }

        const container = target.closest("div");
        if (container && container.classList.contains("brands")) {
            // in der Artikelliste werden die Hersteller 2 mal angezeigt, einmal im Filterlayer und einmal direkt
            // in dem Fall muessen beide Checkboxen synchronisiert werden (anhaken, abhaken)
            const viewroot = target.closest("form") as HTMLElement | null;
            if (viewroot) {
                viewroot
                    .querySelectorAll<HTMLInputElement>(`#${target.id}`)
                    .forEach((checkbox) => {
                        checkbox.checked = target.checked;
                    });
            }
        }

        return this.reloadModule(form);
    }

    public reloadModule(form: HTMLFormElement): Promise<HTMLElement> {
        const moduleRoot = form.closest(".cms-module-root") as HTMLElement;
        if (!moduleRoot) {
            throw new Error("moduleRoot not found");
        }

        const cmsmoduleid = moduleRoot.getAttribute("data-module-id");
        if (!cmsmoduleid) {
            throw new Error("cmsmoduleid not found");
        }

        form = this.setFormData(moduleRoot, form);

        const footnotes = moduleRoot.getAttribute("data-footnotes");
        const formData = new FormData(form);

        let url = moduleRoot.getAttribute("data-modul-url");
        if (!url) {
            url = "";
        }

        document.body.classList.add("loading");

        return this.moduleCallbackMotion(
            cmsmoduleid,
            formData,
            url,
            footnotes ?? undefined,
        )
            .then((response) => response.text())
            .then((data) => {
                document.body.classList.remove("loading");

                let filterStateTariflist = moduleRoot.querySelector(
                    ".drop-panel",
                ) as HTMLElement;
                let openFilterTariflist = false;
                if (
                    filterStateTariflist &&
                    filterStateTariflist.classList.contains("active")
                ) {
                    openFilterTariflist = true;
                }

                let containerFilterTariflist = moduleRoot.querySelector(
                    ".cms-tarif-list-filter",
                );
                let openFilterTariflistMobile = false;
                if (
                    containerFilterTariflist &&
                    containerFilterTariflist.classList.contains("mobile-active")
                ) {
                    openFilterTariflistMobile = true;
                }

                let oldAjaxFootnotes = "";
                if (!moduleRoot.classList.contains("cms-module-offerboxer")) {
                    const footnotesForAjax = moduleRoot.querySelector(
                        "#footnotes_for_ajax",
                    );
                    oldAjaxFootnotes = footnotesForAjax?.innerHTML || "";
                }

                moduleRoot.innerHTML = data;

                const scriptDispatcher = new ScriptDispatcher();
                scriptDispatcher.dispatchScriptTag(data);

                // reinitialize all modules
                new TriggerReloadEvent(moduleRoot);

                // tarifliste > filter wieder oeffnen (drop-panel)
                // erneut suchen da inhalt nun ein anderer ist
                filterStateTariflist = moduleRoot.querySelector(
                    ".drop-panel",
                ) as HTMLElement;
                containerFilterTariflist = moduleRoot.querySelector(
                    ".cms-tarif-list-filter",
                );
                if (openFilterTariflist === true && filterStateTariflist) {
                    filterStateTariflist.classList.add("active");
                    filterStateTariflist.style.display = "block";
                    const moreFilters =
                        moduleRoot.querySelector(".more-filters");
                    if (moreFilters) {
                        moreFilters.innerHTML = "<span>Filter anwenden</span>";
                    }
                    const moreFiltersMobile = moduleRoot.querySelector(
                        ".more-filters-mobile",
                    );
                    if (moreFiltersMobile) {
                        moreFiltersMobile.innerHTML =
                            "<span>Filter anwenden</span>";
                    }
                }
                if (
                    openFilterTariflistMobile === true &&
                    containerFilterTariflist
                ) {
                    containerFilterTariflist.classList.add("mobile-active");
                }

                if (oldAjaxFootnotes) {
                    const completeFootnotes = notNull(
                        document.querySelector("#footnotes_text"),
                    );
                    // damit die rechtstexte nicht doppelt sind, tariflist
                    completeFootnotes.innerHTML =
                        completeFootnotes.innerHTML.replace(
                            oldAjaxFootnotes,
                            "",
                        );

                    const newAjaxFootnotes =
                        moduleRoot.querySelector("#footnotes_for_ajax")
                            ?.innerHTML || "";
                    const ajaxFootnotes =
                        document.querySelector("#ajax_footnotes");

                    if (ajaxFootnotes) {
                        if (!ajaxFootnotes.innerHTML) {
                            ajaxFootnotes.innerHTML = newAjaxFootnotes;
                        } else {
                            ajaxFootnotes.innerHTML =
                                ajaxFootnotes.innerHTML.replace(
                                    oldAjaxFootnotes,
                                    newAjaxFootnotes,
                                );
                        }
                    }
                }

                return moduleRoot;
            })
            .catch((error) => {
                document.body.classList.remove("loading");
                throw error;
            });
    }

    private setFormData(
        moduleRoot: HTMLElement,
        form: HTMLFormElement,
    ): HTMLFormElement {
        const provider = moduleRoot.getAttribute("data-provider");
        if (provider && !form.querySelector('input[name="defaultprovider"]')) {
            const hiddenField = document.createElement("input");
            hiddenField.type = "hidden";
            hiddenField.name = "defaultprovider";
            hiddenField.value = provider;
            form.appendChild(hiddenField);
        }

        const tarifids = moduleRoot.getAttribute("data-tarifids");
        if (tarifids && !form.querySelector('input[name="vtids"]')) {
            const hiddenField = document.createElement("input");
            hiddenField.type = "hidden";
            hiddenField.name = "vtids";
            hiddenField.value = tarifids;
            form.appendChild(hiddenField);
        }

        const isVvl = moduleRoot.getAttribute("data-isVvl");
        if (isVvl && !form.querySelector('input[name="isVvl"]')) {
            const hiddenField = document.createElement("input");
            hiddenField.type = "hidden";
            hiddenField.name = "isVvl";
            hiddenField.value = isVvl;
            form.appendChild(hiddenField);
        }

        return form;
    }

    private moduleCallbackMotion(
        cmsmoduleid: string,
        params: FormData | { name: string; value: string }[],
        loadUrl?: string,
        footnotes?: string,
    ): Promise<Response> {
        const url =
            loadUrl && loadUrl !== ""
                ? loadUrl
                : "/modulecms/api_modulecms_callback";

        if (params instanceof FormData) {
            params.append("cmsmoduleid", cmsmoduleid);
            if (footnotes) {
                params.append("footnotes", footnotes);
            }

            const settings: RequestInit = {
                headers: { "X-Requested-With": "XMLHttpRequest" },
                cache: "default",
                credentials: "same-origin",
                method: "POST",
                body: params,
            };
            return fetch(url, settings);
        }

        const queryParams = new URLSearchParams();
        params.forEach((param) => queryParams.append(param.name, param.value));
        queryParams.append("cmsmoduleid", cmsmoduleid);
        if (footnotes) {
            queryParams.append("footnotes", JSON.stringify(footnotes));
        }

        return fetch(url, {
            method: "POST",
            headers: { "X-Requested-With": "XMLHttpRequest" },
            body: queryParams,
        });
    }
}
